import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth APIs
export const authAPI = {
  login: (email, password) => api.post('/auth/login', { email, password }),
  register: (userData) => api.post('/auth/register', userData),
  getProfile: () => api.get('/auth/profile')
};

// Claims APIs
export const claimsAPI = {
  getAll: () => api.get('/claims'),
  getById: (id) => api.get(`/claims/${id}`),
  getCRMStatus: (id) => api.get(`/claims/${id}/crm-status`)
};

// FAQs APIs
export const faqsAPI = {
  getAll: (claimStatus) => api.get('/faqs', { params: { claim_status: claimStatus } })
};

// Communications APIs
export const communicationsAPI = {
  getAll: (claimId) => api.get('/communications', { params: { claim_id: claimId } }),
  getById: (id) => api.get(`/communications/${id}`),
  markAsRead: (id) => api.put(`/communications/${id}/read`),
  getUnreadCount: () => api.get('/communications/stats/unread')
};

// Attachments APIs
export const attachmentsAPI = {
  upload: (formData) => api.post('/attachments/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }),
  getAll: (claimId) => api.get('/attachments', { params: { claim_id: claimId } }),
  download: (id) => api.get(`/attachments/${id}/download`, { responseType: 'blob' }),
  delete: (id) => api.delete(`/attachments/${id}`)
};

// Claim Info APIs
export const claimInfoAPI = {
  get: (claimId) => api.get(`/claim-info/claim/${claimId}`),
  submit: (claimId, data) => api.post(`/claim-info/claim/${claimId}`, data)
};

export default api;
